export function createCache<T extends {}>(store: Map<string, T>) {
	return {
		get(key: string, supplier: () => T): T {
			const value = store.get(key);
			if (value != null) {
				return value;
			}

			const v = supplier();
			store.set(key, v);
			return v;
		},
	};
}
